import React, { useEffect } from 'react';
import theme from '@/constants/theme';

import { styles } from './styles';
import { Route } from '@/services/routes/route.vm';
import { getContentDetail } from '@/components/routes/common';
import { CheckCircle, EmojiEvents, Star } from '@mui/icons-material';
import { generatePath, Link } from 'react-router';
import { formatContentDuration } from '@/utils/formatContentDuration';
import { Content } from '@/services/contents/content.vm';
import { ContentType } from '@/services/contents/types';
import { routes } from '@/constants/routes';

interface Props {
  id: Content['id'];
  routeId: Route['id'];
  title: string;
  type: ContentType;
  completed?: boolean;
  points?: number;
  duration?: number;
  autoFocus?: boolean;
}

export const ContentCard: React.FC<Props> = ({
  id,
  routeId,
  title,
  type,
  completed,
  points,
  duration,
  autoFocus,
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const contentTypeDetails = getContentDetail(type);

  useEffect(() => {
    if (autoFocus) {
      containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [autoFocus]);

  return (
    <div ref={containerRef} style={styles.itemContainer}>
      <div style={styles.listIndicator} />
      <Link to={generatePath(routes.routes.content.detail, { routeId, contentId: id })}>
        <div style={styles.cardContainer}>
          {autoFocus && (
            <span
              style={{
                backgroundColor: theme.colors.points,
                color: theme.colors.text.contrast,
                width: 'fit-content',
                padding: '2px 8px',
                borderRadius: 16,
                fontSize: 14,
                marginBottom: 4,
                alignItems: 'center',
                display: 'flex',
                fontWeight: 'bold',
                gap: 4,
              }}
            >
              <Star fontSize="small"></Star>
              Puedes seguir con este contenido
            </span>
          )}
          <div style={styles.typeIndicator}>
            <contentTypeDetails.Icon style={{ width: 16, height: 16 }} />
            <p style={styles.type}>
              {contentTypeDetails.title} • {formatContentDuration(duration ?? 60)}
            </p>
          </div>
          <h3 style={styles.cardTitle}>{title}</h3>
          <div style={styles.fixedIndicator}>
            {completed ? (
              <CheckCircle
                sx={{
                  color: theme.colors.success,
                }}
              />
            ) : (
              <div style={styles.pointsContainer}>
                <p style={styles.pointsIndicator}>+ {points}</p>
                <EmojiEvents
                  // name="trophy-variant"
                  // size={16}
                  // color={theme.colors.primary}
                  sx={{
                    color: theme.colors.points,
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
};
